import { FC, ReactNode } from 'react'
import { EmployeeDisplayFragment, EmployeeDisplayShortInfo, MeetingDashboardFragment, MeetingStatus, UserInfo } from '../../../../types'
import { useDateTime } from '../../../../shared/useDateTime'
import PerFlexRow from '../../FlexRow'
import PerText from '../../Text'
import { MeetingTag } from '../../MeetingTag'
import PerSpacer from '../../Spacer'
import { SmartAvatar } from '../../../../modules/avatar/SmartAvatar'
import { computeFullname } from '../../../../shared/nameDisplayPreferencesUtil'

export type MeetingTile = Pick<MeetingDashboardFragment, 'displayDate' | 'status' | 'type'> & { reviewer: EmployeeDisplayShortInfo } & {
  employee: EmployeeDisplayFragment
}
interface Props {
  meeting: MeetingTile
  user: Pick<UserInfo, 'employeeId' | 'timezone' | 'locale' | 'nameDisplayPreference'>
  actionButton?: ReactNode
  employeeView?: boolean
}

export const PerInfoBoxMeetingElement: FC<Props> = ({ meeting, user, actionButton, employeeView }) => {
  const { formatDateShort, formatTimeShort } = useDateTime(user)

  let participant: EmployeeDisplayFragment
  if (employeeView) {
    participant = {
      id: meeting.reviewer.id,
      legalFirstName: meeting.reviewer.firstName,
      legalLastName: meeting.reviewer.lastName,
    }
  } else {
    participant = {
      id: meeting.employee.id,
      legalFirstName: meeting.employee.chosenFirstName ? meeting.employee.chosenFirstName : meeting.employee.legalFirstName,
      legalLastName: meeting.employee.chosenLastName ? meeting.employee.chosenLastName : meeting.employee.legalLastName,
    }
  }

  const isCanceled = meeting.status === MeetingStatus.Canceled

  return (
    <div>
      <PerFlexRow align="middle" className="meetingTile" mb="xxs" noWrap>
        <SmartAvatar employeeId={participant.id} firstName={participant.legalFirstName} lastName={participant.legalLastName} />
        <PerSpacer ml="xxs">
          <MeetingTag type={meeting.type} />
          <PerText mt="xxxs" fontWeight="bold">
            <PerText display="inline" strikeThrough={isCanceled}>
              {formatDateShort(meeting.displayDate)}
            </PerText>
            <PerText display="inline" color="secondary" mx="xxs">
              |
            </PerText>
            <PerText display="inline" strikeThrough={isCanceled}>
              {formatTimeShort(meeting.displayDate)}
            </PerText>
          </PerText>
          <PerText color="secondary" fontSize="s">
            {computeFullname(user.nameDisplayPreference, participant.legalFirstName, participant.legalLastName)}
          </PerText>
        </PerSpacer>
      </PerFlexRow>
      {actionButton}
    </div>
  )
}
